import { render } from "./VirtualRedTagConfirmation.vue?vue&type=template&id=61d757a6&scoped=true&ts=true"
import script from "./VirtualRedTagConfirmation.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagConfirmation.vue?vue&type=script&lang=ts"

import "./VirtualRedTagConfirmation.vue?vue&type=style&index=0&id=61d757a6&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d757a6"]])

export default __exports__